import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import '@grandvisionhq/utils';
import { usePaymentsUIContext } from '../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import useCheckout from '../../../../../hooks/adyen/useCheckout.js';
import { AdyenPaymentType } from '../../../../../models/adyen/payment-type.js';
import '@grandvisionhq/icons';
import '../../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../../models/payment/types.js';
import '../../../../../models/paypal/context.js';
import { getBrowserInfo } from '../../../../../utils/get-browser-info.js';
import { PaymentMethodFormContainer } from '../PaymentMethodForm/containers/PaymentMethodFormContainer.js';

var ref, ref1, ref2, ref3, ref4;
const toPaymentMethodFormState = (state, type, cardBrand)=>{
    var ref14, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    return {
        cardBrand,
        isValid: state.isValid,
        data: swcHelpers.objectSpread({
            browserInfo: getBrowserInfo(),
            holderName: (ref = state === null || state === void 0 ? void 0 : (ref14 = state.data) === null || ref14 === void 0 ? void 0 : (ref5 = ref14.paymentMethod) === null || ref5 === void 0 ? void 0 : ref5.holderName) !== null && ref !== void 0 ? ref : '',
            encryptedCardNumber: (ref1 = state === null || state === void 0 ? void 0 : (ref6 = state.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.paymentMethod) === null || ref7 === void 0 ? void 0 : ref7.encryptedCardNumber) !== null && ref1 !== void 0 ? ref1 : '',
            encryptedExpiryMonth: (ref2 = state === null || state === void 0 ? void 0 : (ref8 = state.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.paymentMethod) === null || ref9 === void 0 ? void 0 : ref9.encryptedExpiryMonth) !== null && ref2 !== void 0 ? ref2 : '',
            encryptedExpiryYear: (ref3 = state === null || state === void 0 ? void 0 : (ref10 = state.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.paymentMethod) === null || ref11 === void 0 ? void 0 : ref11.encryptedExpiryYear) !== null && ref3 !== void 0 ? ref3 : ''
        }, type === AdyenPaymentType.Bancontact ? {} : {
            encryptedSecurityCode: (ref4 = state === null || state === void 0 ? void 0 : (ref12 = state.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.paymentMethod) === null || ref13 === void 0 ? void 0 : ref13.encryptedSecurityCode) !== null && ref4 !== void 0 ? ref4 : ''
        })
    };
};
const CreditCardContainer = ({ onChange , additionalOptions , type =AdyenPaymentType.Card ,  })=>{
    const { setCurrentCardBrand  } = usePaymentsUIContext();
    const [state, setState] = React.useState();
    const [brand, setBrand] = React.useState();
    const checkout = useCheckout(setState);
    const additional = React.useMemo(()=>{
        return swcHelpers.objectSpread({
            hasHolderName: true,
            holderNameRequired: true
        }, additionalOptions, {
            onBrand: (obj)=>{
                var ref15;
                additionalOptions === null || additionalOptions === void 0 ? void 0 : (ref15 = additionalOptions.onBrand) === null || ref15 === void 0 ? void 0 : ref15.call(additionalOptions, obj);
                setBrand(obj.brand);
                // if the brand is undetected the brand is set to card which is irrelevant to us
                setCurrentCardBrand(obj.brand !== 'card' ? obj.brand : undefined);
            }
        });
    }, [
        additionalOptions,
        setCurrentCardBrand
    ]);
    React.useEffect(()=>{
        if (state) {
            onChange(toPaymentMethodFormState(state, type, brand));
        }
    }, [
        brand,
        state,
        onChange,
        type
    ]);
    return /*#__PURE__*/ React.createElement(PaymentMethodFormContainer, {
        type: type,
        checkout: checkout,
        additionalOptions: additional
    });
};

export { CreditCardContainer };
//# sourceMappingURL=CreditCardContainer.js.map
